import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const ease = [0.16, 1, 0.3, 1];
const STUDIO_IMG =
  "https://customer-assets.emergentagent.com/job_workout-assessment/artifacts/pgynivhn_5B6DFB57-591D-4050-8374-662A71112600.PNG";

const stats = [
  { k: "312", v: "trasformazioni concluse" },
  { k: "8", v: "anni di studio privato" },
  { k: "24h", v: "risposta garantita" },
];

export default function StudioSection() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section
      id="studio"
      ref={ref}
      data-testid="studio-section"
      className="relative bg-onyx py-28 md:py-40 overflow-hidden"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease }}
          className="md:col-span-6 relative"
        >
          <div className="editorial-frame aspect-[4/3] w-full overflow-hidden">
            <motion.img
              src={STUDIO_IMG}
              alt="Lo studio BBfit"
              style={{ y }}
              className="w-full h-[115%] object-cover"
              draggable={false}
            />
          </div>
          <div className="absolute -bottom-6 -right-6 md:-right-10 bg-gold text-obsidian px-6 py-4 hidden md:block">
            <div className="font-serif italic text-2xl leading-none">Conegliano</div>
            <div className="text-[0.62rem] uppercase tracking-[0.32em] mt-1">Studio privato</div>
          </div>
        </motion.div>

        <div className="md:col-span-6 md:pl-8">
          <motion.span
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, ease }}
            className="text-[0.7rem] uppercase tracking-[0.4em] text-gold flex items-center gap-3"
          >
            <span className="w-8 h-px bg-gold" /> Lo studio
          </motion.span>

          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1, ease, delay: 0.1 }}
            className="mt-6 font-serif font-light text-cream text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-[-0.02em]"
          >
            Un ambiente pensato per <em className="italic text-gold/90">chi fa sul serio.</em>
          </motion.h2>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1, ease, delay: 0.2 }}
            className="mt-6 max-w-lg text-cream/70 font-light text-base md:text-lg leading-relaxed"
          >
            Nessun rumore, nessuna folla. Solo tu, un coach dedicato e il tempo
            necessario per costruire un corpo che rifletta chi stai diventando.
          </motion.p>

          <div className="mt-14 grid grid-cols-2 gap-y-10 gap-x-6 border-t border-cream/10 pt-10">
            {stats.map((s, i) => (
              <motion.div
                key={s.k}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.9, ease, delay: 0.1 + i * 0.08 }}
              >
                <div className="font-serif font-light text-cream text-5xl md:text-6xl leading-none">
                  {s.k}
                </div>
                <div className="mt-3 text-[0.65rem] uppercase tracking-[0.32em] text-cream/50">
                  {s.v}
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
